import React from "react";

// Reusable SVG logo marks for the platforms Leadmato actually scans.
// Kept in sync with backend/pipeline.py `_INTEGRATED`
//   = { reddit, linkedin, youtube, instagram, forums, facebook, web, news,
//       twitter (X), tiktok }
// plus Reddit comments (community feed). X → Find Customers lens, TikTok →
// Partners lens (creators/affiliates). Quora is the only hard-blocked one.
// Each returns a self-contained SVG with the brand color baked in.
export function SocialLogo({ platform, className = "w-5 h-5" }) {
  const key = (platform || "").toLowerCase();

  if (key === "reddit" || key === "reddit-comments") {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-label="Reddit">
        <circle cx="20" cy="20" r="20" fill="#FF4500" />
        <path
          fill="#fff"
          d="M31 20a3 3 0 0 0-5.1-2.1c-1.8-1.2-4.2-2-6.8-2.1l1.4-4.4 3.6.8v.1a2 2 0 1 0 .7-1.6l-4.2-.9a.5.5 0 0 0-.6.3l-1.6 5a12 12 0 0 0-6.8 2A3 3 0 1 0 9 20.4c0 .3-.1.6-.1.9 0 4.4 5 8 11.1 8s11.1-3.6 11.1-8c0-.3 0-.6-.1-1 1.1-.5 1.9-1.6 1.9-2.9zm-17.4 2.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm10 5.1c-1.3.9-3 1.4-4.6 1.4s-3.3-.4-4.6-1.4a.5.5 0 1 1 .6-.8c1 .7 2.5 1.1 4 1.1s3-.4 4-1.1a.5.5 0 1 1 .6.8zm-.3-3a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
        />
      </svg>
    );
  }
  if (key === "linkedin") {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-label="LinkedIn">
        <rect width="40" height="40" rx="8" fill="#0A66C2" />
        <path
          fill="#fff"
          d="M13.5 15.5v14h-4v-14h4zM11.5 8a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8zM31 22.4v7.1h-4v-6.6c0-1.6-.6-2.7-2.1-2.7-1.1 0-1.8.7-2.1 1.5-.1.3-.2.6-.2 1v6.8h-4v-14h4v1.9c.5-.9 1.5-2.2 3.7-2.2 2.7 0 4.7 1.8 4.7 5.2z"
        />
      </svg>
    );
  }
  if (key === "youtube") {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-label="YouTube">
        <rect width="40" height="40" rx="8" fill="#FF0000" />
        <path fill="#fff" d="M17 14.5v11l9.5-5.5L17 14.5z" />
      </svg>
    );
  }
  if (key === "instagram") {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-label="Instagram">
        <defs>
          <radialGradient id="lm-ig" cx="0.3" cy="1" r="1.1">
            <stop offset="0" stopColor="#FEDA75" />
            <stop offset="0.35" stopColor="#FA7E1E" />
            <stop offset="0.6" stopColor="#D62976" />
            <stop offset="0.85" stopColor="#962FBF" />
            <stop offset="1" stopColor="#4F5BD5" />
          </radialGradient>
        </defs>
        <rect width="40" height="40" rx="10" fill="url(#lm-ig)" />
        <rect x="11" y="11" width="18" height="18" rx="5.5" fill="none" stroke="#fff" strokeWidth="2.4" />
        <circle cx="20" cy="20" r="4.4" fill="none" stroke="#fff" strokeWidth="2.4" />
        <circle cx="25.4" cy="14.6" r="1.4" fill="#fff" />
      </svg>
    );
  }
  if (key === "facebook") {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-label="Facebook">
        <rect width="40" height="40" rx="8" fill="#1877F2" />
        <path
          fill="#fff"
          d="M25.6 20.3l.6-3.9h-3.7v-2.5c0-1.1.5-2.1 2.2-2.1h1.7V8.4c-1-.2-2.1-.3-3.1-.3-3.2 0-5.3 1.9-5.3 5.5v3.1h-3.4v3.9h3.4V32h4.3v-11.7h3z"
        />
      </svg>
    );
  }
  if (key === "forums") {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-label="Forums">
        <rect width="40" height="40" rx="8" fill="#1F4A38" />
        <path
          fill="#fff"
          d="M11 13.5A2.5 2.5 0 0 1 13.5 11h9A2.5 2.5 0 0 1 25 13.5v5A2.5 2.5 0 0 1 22.5 21H17l-4 3v-3h-.5A1.5 1.5 0 0 1 11 19.5v-6z"
          opacity="0.95"
        />
        <path
          fill="#8FD3B6"
          d="M27 17h1.5A2.5 2.5 0 0 1 31 19.5v6a1.5 1.5 0 0 1-1.5 1.5H29v3l-4-3h-5A2.5 2.5 0 0 1 17.6 25H22.5a4.5 4.5 0 0 0 4.5-4.5V17z"
        />
      </svg>
    );
  }
  if (key === "web") {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-label="Web">
        <rect width="40" height="40" rx="8" fill="#2563EB" />
        <circle cx="20" cy="20" r="9" fill="none" stroke="#fff" strokeWidth="2" />
        <path
          fill="none"
          stroke="#fff"
          strokeWidth="2"
          d="M11 20h18M20 11c2.8 2.5 4.3 5.7 4.3 9s-1.5 6.5-4.3 9c-2.8-2.5-4.3-5.7-4.3-9s1.5-6.5 4.3-9z"
        />
      </svg>
    );
  }
  if (key === "news") {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-label="News">
        <rect width="40" height="40" rx="8" fill="#D95A40" />
        <rect x="12" y="12" width="15" height="16" rx="2" fill="#fff" />
        <path d="M29 17h1.5a1.5 1.5 0 0 1 1.5 1.5V26a2 2 0 0 1-2 2h-.5" fill="none" stroke="#fff" strokeWidth="2" />
        <rect x="15" y="15.5" width="9" height="3.5" rx="0.8" fill="#D95A40" />
        <rect x="15" y="21" width="9" height="1.6" rx="0.8" fill="#D95A40" opacity="0.5" />
        <rect x="15" y="24" width="6" height="1.6" rx="0.8" fill="#D95A40" opacity="0.5" />
      </svg>
    );
  }
  if (key === "twitter" || key === "x") {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-label="X">
        <rect width="40" height="40" rx="8" fill="#000" />
        <path
          fill="#fff"
          d="M22.9 18.6 30.3 10h-1.8l-6.4 7.5L17 10h-6l7.8 11.3L11 30h1.8l6.8-7.9L25 30h6l-8.1-11.4zm-2.4 2.8-.8-1.1-6.3-9h2.7l5 7.2.8 1.1 6.6 9.4h-2.7l-5.3-7.6z"
        />
      </svg>
    );
  }
  if (key === "tiktok") {
    const note =
      "M22.5 10c.3 2.4 1.7 4.3 4 4.9.8.2 1.6.3 2.4.3v3.4c-1.6 0-3.1-.4-4.5-1.1v6.9c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7c.4 0 .7 0 1.1.1v3.5c-.4-.1-.7-.2-1.1-.2-1.9 0-3.4 1.5-3.4 3.4s1.5 3.4 3.4 3.4 3.4-1.5 3.4-3.4V10h3.7z";
    return (
      <svg viewBox="0 0 40 40" className={className} aria-label="TikTok">
        <rect width="40" height="40" rx="8" fill="#000" />
        <path d={note} fill="#25F4EE" transform="translate(-1.1 -1.1)" />
        <path d={note} fill="#FE2C55" transform="translate(1.1 1.1)" />
        <path d={note} fill="#fff" />
      </svg>
    );
  }
  return null;
}

export const SUPPORTED_PLATFORMS = [
  { id: "reddit", name: "Reddit posts & comments", subtitle: "Subreddits, niche communities & thread replies", color: "#FF4500" },
  { id: "forums", name: "Forums", subtitle: "Niche community & Q&A boards", color: "#1F4A38" },
  { id: "linkedin", name: "LinkedIn", subtitle: "Public professional posts", color: "#0A66C2" },
  { id: "twitter", name: "X (Twitter)", subtitle: "Public posts & replies", color: "#000000" },
  { id: "youtube", name: "YouTube", subtitle: "Comments on relevant videos", color: "#FF0000" },
  { id: "instagram", name: "Instagram", subtitle: "Public posts & captions", color: "#E4405F" },
  { id: "facebook", name: "Facebook", subtitle: "Public pages & groups", color: "#1877F2" },
  { id: "tiktok", name: "TikTok", subtitle: "Creator & affiliate videos", color: "#000000" },
  { id: "web", name: "Web", subtitle: "Blogs, articles & open pages", color: "#2563EB" },
  { id: "news", name: "News", subtitle: "Fresh press & announcements", color: "#D95A40" },
];
